// extracted by mini-css-extract-plugin
export default {"root":"StoryStatusText-root-9766aa9fa324fb26d3ca67ac870eea87","open":"StoryStatusText-open-923bcf3bd7f6f74b225ff4baecd51d08"};